import type {BootstrapResult} from "app/employee/state/bootstrapEmployee/mutations";
import {Trans, useTranslation} from "react-i18next";

export const LoggedOutMenuItems = ({bootstrapResult}: {bootstrapResult?: BootstrapResult}) => {
  const {t} = useTranslation();

  if (bootstrapResult?.__typename !== "Public") {
    return null;
  }

  return (
    <div className="ion-padding-horizontal" style={{hyphens: "auto"}}>
      <p>
        <strong>{t("menu.logged-out.already-part-of-team")}</strong>
        <br />
        {t("menu.logged-out.contact-admin-for-code")}
      </p>

      <hr />

      <strong>{t("menu.logged-out.want-to-digitize-question")}</strong>

      <p>{t("menu.logged-out.contact-us-to")}</p>
      <ul>
        <li>
          <Trans i18nKey="menu.logged-out.get-to-know-services">
            се <strong>запознаете</strong> с нашите дигитални услуги.
          </Trans>
        </li>
        <li>
          <Trans i18nKey="menu.logged-out.get-demo">
            получите <strong>кратко демо</strong> на платформата.
          </Trans>
        </li>
        <li>
          <Trans i18nKey="menu.logged-out.fully-digitize">
            <strong>дигитализирате изцяло</strong> контрола на хранителната безопасност.
          </Trans>
        </li>
      </ul>

      <p>
        <strong>{t("menu.logged-out.email")}:</strong> <a href="mailto:office@fsacademy.bg">office@fsacademy.bg</a>
        <br />
        <strong>{t("menu.logged-out.phone")}:</strong>{" "}
        <a href="tel:+359895775512" rel="noreferrer" target="_blank">
          +359 895 77 55 12
        </a>
      </p>
    </div>
  );
};
